import { processLocalizedURLAddress } from '@vue-storefront/core/helpers'
import { TaskQueue } from '@vue-storefront/core/lib/sync'
import RootState from '@vue-storefront/core/types/RootState'
import { Module } from 'vuex'
import config from 'config'
import { StorageManager } from '@vue-storefront/core/lib/storage-manager'

function normalizeSessionResult (result) {
  if (!Array.isArray(result)) {
    return result
  }

  return {
    quote_id: result[0] || null,
    order_id: result[1] || '',
    status: result[2] || '',
    html_snippet: result[3] || '',
    iframe_url: result[4] || ''
  }
}

export const module: Module<any, RootState> = {
  namespaced: true,
  actions: {
    async createSession ({ rootGetters }, { shippingMethod = '' } = {}) {
      const endpoint = config.kustom.sessionStartEndpoint
      const cartToken = rootGetters['cart/getCartToken']

      if (!endpoint || !cartToken) {
        return null
      }

      const response = await TaskQueue.execute({
        url: processLocalizedURLAddress(endpoint),
        payload: {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          mode: 'cors',
          body: JSON.stringify({
            cartToken,
            shippingMethod
          })
        }
      })

      return response?.code === 200 && response.result ? normalizeSessionResult(response.result) : null
    },
    async updateSession ({ rootGetters }, { shippingMethod = '' } = {}) {
      const endpoint = config.kustom.sessionUpdateEndpoint
      const cartToken = rootGetters['cart/getCartToken']

      if (!endpoint || !cartToken) {
        return null
      }

      const response = await TaskQueue.execute({
        url: processLocalizedURLAddress(endpoint),
        payload: {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          mode: 'cors',
          body: JSON.stringify({
            cartToken,
            shippingMethod
          })
        }
      })

      return response?.code === 200 && response.result ? normalizeSessionResult(response.result) : null
    },
    async saveKustomConfirmation (context, payload) {
      const kustomStorage = StorageManager.get('kustom')
      const timestamp = new Date().toISOString()

      await Promise.all([
        kustomStorage.setItem('confirmation', payload?.confirmation || {}),
        kustomStorage.setItem('order', payload?.order || {}),
        kustomStorage.setItem('orderTotals', payload?.totals || []),
        kustomStorage.setItem('confirmationTime', timestamp)
      ])
    },
    clearKustomStorage () {
      const kustomStorage = StorageManager.get('kustom')
      kustomStorage.removeItem('orderTotals')
      kustomStorage.removeItem('confirmation')
      kustomStorage.removeItem('order')
      kustomStorage.removeItem('confirmationTime')
      kustomStorage.removeItem('session')
    }
  }
}
